import React, {Component} from 'react';
import {Button, Icon} from 'antd';

import './index.css';

class PlayControls extends Component {

  constructor(props) {
    super(props);

    this.state = {
      playing: false,
      count: 0
    }
  }

  componentWillUnmount() {
    this.stop();
  }

  setYear(year) {
    this.setState({year});

    if (this.props.yearChange) {
      this.props.yearChange(year);
    }
  }

  backClick() {
    this.stop();

    let newYear = this.props.year - 1;
    if (newYear < 2007) {
      newYear = 2015;
    }
    this.setYear(newYear);
  }

  forwardClick() {
    this.stop();

    let newYear = this.props.year + 1;
    if (newYear > 2015) {
      newYear = 2007;
    }
    this.setYear(newYear);
  }

  playClick() {
    this.state.playing ? this.stop() : this.play();
  }

  play() {
    this.setYear(2007);
    this.setState({playing: true});
    this.timer = setInterval(this.tick.bind(this), 1000);
  }

  stop() {
    this.setState({playing: false, count: 0});
    clearInterval(this.timer);
  }

  tick() {
    let newYear = this.props.year + 1;

    if (newYear > 2015) {
      const count = this.state.count;

      if (count > 2) {
        this.stop();
      }
      else {
        this.setState({count: count + 1});
        this.setYear(2007);
      }
    }
    else {
      this.setYear(newYear);
    }
  }

  render() {
    return (
      <div className="PlayControls">
        <Button.Group type="primary" size="small" style={{marginTop: '-4px'}}>
          <Button onClick={this.playClick.bind(this)}>
            {this.state.playing ? (
              <Icon type="pause" style={{color: '#fff'}}/>
            ) : (
              <Icon type="caret-right" style={{color: '#00ccff'}}/>
            )}
          </Button>
          <Button onClick={this.backClick.bind(this)}>
            <Icon type="step-backward"/>
          </Button>
          <Button onClick={this.forwardClick.bind(this)}>
            <Icon type="step-forward"/>
          </Button>
        </Button.Group>
      </div>
    );
  }
}

export default PlayControls;



// WEBPACK FOOTER //
// ./src/components/PlayControls/index.js